import { createAsyncThunk } from '@reduxjs/toolkit';

// Type-only imports, so a slice can use this without importing the store it is part of.
import type { AppDispatch, RootState } from './index';

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: RootState;
  dispatch: AppDispatch;
  rejectValue: string;
}>();
